/**
 * HIPAA: Wraps fetch() to attach Firebase App Check token + Firebase ID token.
 * App Check proves the request comes from a legitimate app instance.
 * The ID token proves which authenticated user is making the request.
 */
import { getToken } from 'firebase/app-check';
import { appCheck, auth } from '../firebase.config';

export async function fetchWithAppCheck(url, options = {}) {
  const headers = { ...(options.headers || {}) };

  // Attach App Check token
  if (appCheck) {
    try {
      const tokenResult = await getToken(appCheck);
      headers['X-Firebase-AppCheck'] = tokenResult.token;
    } catch (_) {
      // App Check token failed — request will be rejected server-side if enforcement is on
    }
  }

  // Attach Firebase ID token for authenticated requests
  if (auth.currentUser) {
    try {
      headers['Authorization'] = `Bearer ${await auth.currentUser.getIdToken()}`;
    } catch (_) {
      // ID token unavailable — server will return 401 for protected endpoints
    }
  }

  return fetch(url, { ...options, headers });
}

/**
 * Returns headers object with App Check token + Firebase ID token.
 * Use this to merge with axios config or other HTTP clients.
 */
export async function getAppCheckHeaders() {
  const headers = {};

  if (appCheck) {
    try {
      const tokenResult = await getToken(appCheck);
      headers['X-Firebase-AppCheck'] = tokenResult.token;
    } catch (_) {}
  }

  if (auth.currentUser) {
    try {
      headers['Authorization'] = `Bearer ${await auth.currentUser.getIdToken()}`;
    } catch (_) {}
  }

  return headers;
}
